// a06 — every displayed number follows the APP language (getLocale), never the browser.
// EN: 30,744,298 · 23.4 MW · $8.0/GJ · 31.4%   FR: 30 744 298 $ · 23,4 MW · 8,0 $/GJ · 31,4 %
import { getLocale } from "./i18n";

export const NBSP = "\u00a0";
const fr = () => getLocale() === "fr";

// Plain number; max `d` decimals, at least `min`.
export const num = (v, d = 1, min = 0) => {
  const s = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: d, minimumFractionDigits: Math.min(min, d),
  }).format(Number(v) || 0);
  return fr() ? s.replace(/,/g, NBSP).replace(".", ",") : s;
};

// $ amount: EN "$1,234", FR "1 234 $". Sign stays in front.
export const money = (v, d = 0, min = 0) => {
  const n = Number(v) || 0;
  const body = num(Math.abs(n), d, min);
  const sign = n < 0 ? "−" : "";
  return fr() ? `${sign}${body}${NBSP}$` : `${sign}$${body}`;
};

// Millions of $: EN "$1.23M", FR "1,23 M$".
export const moneyM = (v, d = 2) => {
  const n = Number(v) || 0;
  const body = num(Math.abs(n) / 1e6, d, d);
  const sign = n < 0 ? "−" : "";
  return fr() ? `${sign}${body}${NBSP}M$` : `${sign}$${body}M`;
};

// Percent of an already-scaled value: EN "31.4%", FR "31,4 %".
export const pct = (v, d = 1, min = d) => `${num(v, d, min)}${fr() ? NBSP : ""}%`;

// Number with a unit: "23.4 MW" / "23,4 MW" (no-break space in both).
export const unit = (v, u, d = 1, min = 0) => `${num(v, d, min)}${NBSP}${u}`;

// $ per unit: EN "$8.0/GJ", FR "8,0 $/GJ".
export const perUnit = (v, u, d = 1, min = d) =>
  (fr() ? `${num(v, d, min)}${NBSP}$/${u}` : `$${num(v, d, min)}/${u}`);

// Per year suffix: EN "/yr", FR "/an".
export const perYr = () => (fr() ? "/an" : "/yr");

// Read a typed value in either language: "1 234,5", "1,234.5", "8,0" → number (NaN if empty).
export const parseNum = (s) => {
  if (typeof s === "number") return s;
  let t = String(s ?? "").replace(/[\s\u00a0\u202f]/g, "");
  if (t === "") return NaN;
  const lc = t.lastIndexOf(","), ld = t.lastIndexOf(".");
  if (lc > -1 && ld > -1) {
    t = lc > ld ? t.replace(/\./g, "").replace(",", ".") : t.replace(/,/g, "");
  } else if (lc > -1) {
    t = !fr() && /^-?\d{1,3}(,\d{3})+$/.test(t) ? t.replace(/,/g, "") : t.replace(",", ".");
  }
  return Number(t);
};

// Thousands of $ for chart ticks: EN "$5k", FR "5 k$".
export const moneyK = (v, d = 0) => (fr() ? `${num(v / 1000, d)}${NBSP}k$` : `$${num(v / 1000, d)}k`);
